export const actionTypes = {
  REQUEST_START: 'PROFILE.REGISTRATION_STATUS.REQUEST_START',
  REQUEST_SUCCESS: 'PROFILE.REGISTRATION_STATUS.REQUEST_SUCCESS',
  REQUEST_FAILURE: 'PROFILE.REGISTRATION_STATUS.REQUEST_FAILURE',
};

export function startRequest() {
  return {
    type: actionTypes.REQUEST_START,
  };
}

export function requestSuccess(data) {
  return {
    type: actionTypes.REQUEST_SUCCESS,
    payload: data,
  };
}

export function requestFailure(error) {
  return {
    type: actionTypes.REQUEST_FAILURE,
    payload: error,
  };
}
